export default {
    OK: 0,
    DeliveryMethodPrintYourOwn: 1,
    TicketsNotConfirmed: 2,
    NoItemsAvailable: 3,
    AlreadyAmended: 4,
    InAmendmentApprovalProcess: 5,
    InternetOnlyBooking: 6,
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/can-be-amended-statuses.js